module.exports = __webpack_public_path__ + "img/icon_coupon.acbc1cff.svg";